import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {getTopClients} from "../../store/reducers/ClientsSlice";
import RangeSearch from "./components/RangeSearch";
import {getAmounts} from "../../store/reducers/ResultsSlice";

interface AmountResultsScreenProps {
}

export const AmountResultsScreen: React.FC<AmountResultsScreenProps> = () => {

    const dispatch = useAppDispatch();

    const resultsState = useAppSelector(state => state.results);

    useEffect(() => {
        dispatch(getAmounts());
    }, []);

    return (
        <LoggedInView fullWidth={false}>
            <h1>Päringute ülevaade koguse järgi</h1>
            <RangeSearch url={'results/status'} userVisible={true} />
            <table className="data">
                <thead>
                <tr>
                    <th className="left">Kogus</th>
                    <th className="left">
                        Arv
                        <a style={{ textDecoration: 'none' }} href="#">
                            ▲
                        </a>
                        <a style={{ textDecoration: 'none' }} href="#">
                            ▼
                        </a>
                    </th>
                    <th className="left">
                        Osakaal kogu päringutest
                        <a style={{ textDecoration: 'none' }} href="#">
                            ▲
                        </a>
                        <a style={{ textDecoration: 'none' }} href="#">
                            ▼
                        </a>
                    </th>
                    <th className="left">Vedusid</th>
                    <th className="left">Koguse grupi realiseerimine</th>
                </tr>
                </thead>
                <tbody>
                {resultsState.amounts.map(amount => (
                    <tr>
                        <td>{amount.name}</td>
                        <td>{amount.amount}</td>
                        <td>{amount.percentage}</td>
                        <td>{amount.realised}</td>
                        <td>{amount.realisedPercentage}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </LoggedInView>
    )

}